import React from "react";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import "./App.css";
import router from "./Routers/Router";
import useDashboardPermission from "./hooks/useDashboardPermission";

function App() {
  const theme = {
    color: {
      primary: "#404040",
      secondary: "red",
      bg: "white",
      bgSecondary: "#dad9d9",
      bgTertiary: "#EFF2F9",
      bgQuaternary: "#F5F5F5",
      invertedPrimary: "white",
      invertedBg: "black",
      borderPrimary: "#EBEBEB",
      rating: "#FFA41C",
    },
  };
  const [dashboardPermissionData] = useDashboardPermission();

  const objects = {};

  dashboardPermissionData.forEach((item) => {
    const variableName = `a${item.sa_mlinks_id}b`;
    objects[variableName] = {
      abc: item.active_fg,
    };
  });

  // console.log("userData", dashboardPermissionData);

  // console.log("objects", objects);

  localStorage.setItem("items", JSON.stringify(objects));
  return (
    <div>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router}></RouterProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
